const STORAGE_KEY = 'pf_eval_year';

/** 앱에서 사용 가능한 평가연도 목록 (과거 2년 ~ 2030) */
export function availableEvalYears(now = new Date()): number[] {
  const start = now.getFullYear() - 2;
  const end = 2030;
  const years: number[] = [];
  for (let y = end; y >= start; y -= 1) {
    years.push(y);
  }
  return years;
}

export function defaultEvalYear(now = new Date()): number {
  return now.getFullYear();
}

export function readStoredEvalYear(): number {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const n = raw ? Number(raw) : NaN;
    if (Number.isFinite(n) && n >= 2000 && n <= 2100) return n;
  } catch {
    /* ignore */
  }
  return defaultEvalYear();
}

export function writeStoredEvalYear(year: number) {
  try {
    localStorage.setItem(STORAGE_KEY, String(year));
  } catch {
    /* ignore */
  }
}

/** 문서에 연도가 없으면 레거시(선택 연도와 동일 취급할 때)로 볼지 여부 */
export function matchesEvalYear(
  docYear: unknown,
  activeYear: number,
  legacyYear: number = defaultEvalYear()
): boolean {
  if (docYear == null || docYear === '') {
    // 예전 데이터: 기본(현재) 연도에서만 보이게
    return activeYear === legacyYear;
  }
  return Number(docYear) === Number(activeYear);
}

export function peerEvalDocId(year: number, evaluatorId: string, colleagueId: string, questionId: number | string) {
  return `${year}_${evaluatorId}_${colleagueId}_${questionId}`;
}

export function peerCommentDocId(year: number, evaluatorId: string, colleagueId: string) {
  return `${year}_${evaluatorId}_${colleagueId}`;
}

export function peerContribDocId(year: number, evaluatorId: string, colleagueId: string) {
  return `${year}_${evaluatorId}_${colleagueId}`;
}

export function peerSummaryDocId(year: number, colleagueId: string) {
  return `${year}_${colleagueId}`;
}

export function poolDocId(year: number, subjectId: string) {
  return `${year}_${subjectId}`;
}
